<template>
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
        >
          <div class="row">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_title">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_title"
                type="text"
                v-model="detail.title"
                placeholder="Enter Title"
                :read-only="true"
              />
            </div>
          </div>
          <div class="row" v-if="showDescriptionEditor">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_description">
                {{ $t("description") }}
              </label>
              <p v-html="detail.description"></p>
              <!-- <app-input
                id="inputs_description"
                type="text-editor"
                placeholder="Enter Description"
                v-model="detail.description"
                :read-only="true"
              /> -->
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_disclaimer">
                {{ $t("disclaimer") }}
              </label>
              <app-input
                id="inputs_disclaimer"
                type="textarea"
                placeholder="Enter Disclaimer"
                v-model="detail.disclaimer"
                :read-only="true"
              />
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_category_name" >
                {{ $t("select_category") }}
              </label>
              <app-input
                id="inputs_category_name"
                type="search-select"
                placeholder="Select Category"
                v-model="inputs.category_id"
                :list='categorylist'
              />
              <p v-if="categoryAddShow == false" class="font-italic text-muted">
                {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
              </p>
              <div v-if="categoryAddShow == true" class="mt-2">
                <div class="d-flex align-items-center">
                  <app-input
                    class="mr-2 flex-grow-1"
                    type="text"
                    placeholder="Enter Category Name"
                    v-model="category_name"/>
                  <button type="submit"
                    class="btn btn-sm btn-primary mr-2"
                    @click.prevent="createCategory()">
                    {{ $t('save') }}
                  </button>
                  <a href="#" class="text-muted" @click.prevent="closeCategory()">
                      <app-icon name="x"/>
                  </a>
                </div>
                <small class="text-danger ml-2" v-html="message"></small>
              </div>
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_package_id">
                {{ $t("select_package") }}
              </label>
              <app-input
                id="inputs_package_id"
                type="search-select"
                placeholder="Select Package"
                v-model="inputs.package_id"
                :list='packageList'
              />
              <p class="font-italic text-primary">
                {{ $t("package_assign_certificate") }}
              </p>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-12 form-group align-items-center">
              <label for="inputs_expire_day">
                {{ $t("enter_expire_day") }}
              </label>
              <app-input
                id="inputs_expire_day"
                type="number"
                placeholder="Enter Numbers of Days"
                v-model="detail.expire_day"
                :read-only="true"
              />
            </div>
          </div>
        </form>
      </template>
    </modal>
  </template>
  
  <script>
  import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
  import { ModalMixin } from "../../../../../Mixins/ModalMixin";  
  export default {
    name: "AddModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        detail: Object,
    },
    data() {
      return {
        modalId: "view-detail-Modal",
        modalTitle: this.$t("detail"),
        showDescriptionEditor: false,
      }
    },
    created() {
        this.showDescriptionEditor = true;
    },
    methods: {
    },
  
    mounted() {
      $(function () {
        $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      });
    },
  };
  </script>
  